import { render, staticRenderFns } from "./maike.vue?vue&type=template&id=622d5750&scoped=true"
import script from "./maike.vue?vue&type=script&lang=js"
export * from "./maike.vue?vue&type=script&lang=js"
import style0 from "./maike.vue?vue&type=style&index=0&id=622d5750&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d5750",
  null
  
)

export default component.exports